const FILL = {
  working: "from-green-400 via-emerald-500 to-emerald-600",
  done: "from-green-400 via-emerald-500 to-emerald-600",
  absent: "from-green-400 via-emerald-500 to-emerald-600",
  idle: "from-green-400 via-emerald-500 to-emerald-600",
  off: "from-sky-400 via-sky-500 to-sky-600",
  leave: "from-amber-300 via-amber-400 to-amber-500",
};

const CHIP = {
  working: "bg-primary text-primary-foreground",
  done: "bg-sky-500 text-white",
  absent: "bg-destructive text-white",
  idle: "bg-muted text-muted-foreground",
  off: "bg-sky-500 text-white",
  leave: "bg-amber-500 text-white",
};

const KNOB = "radial-gradient(circle at 34% 26%, #ffffff 0%, #eef1f5 14%, #c3ccd6 42%, #8b95a1 70%, #4d5561 100%)";

// الساعات والحالة أعلى الشريط · تعبئة زاهية بحسب الحالة · مقبض نيكل متعدد الحلقات داخل الشريط.
export const ShiftTrack = ({ pct, kind, start, end, owed, title, status }) => (
  <div>
    <div className="flex items-center justify-between gap-2">
      <span className="flex items-center gap-1.5 font-mono text-base font-black tracking-tight text-primary"
            data-testid="shift-start">
        <span className="h-2 w-2 rounded-full bg-primary" /> {start}
      </span>
      <span className="flex items-center gap-2 font-sans text-[13px] font-black" data-testid="shift-state">
        {title ? <span className="text-muted-foreground">{title}</span> : null}
        <span className={`rounded-full px-3 py-1 text-[13px] font-black shadow-neu-sm ${CHIP[kind]}`}>{status}</span>
      </span>
      <span className="flex items-center gap-1.5 font-mono text-base font-black tracking-tight text-primary"
            data-testid="shift-end">
        {owed ? `${end} +${owed}` : end} <span className="h-2 w-2 rounded-full bg-primary" />
      </span>
    </div>

    <div className="relative mt-3 h-11" data-testid="shift-track">
      <div className="absolute inset-x-0 top-1/2 h-4 -translate-y-1/2 overflow-hidden rounded-full bg-secondary/70 shadow-neu-in">
        <div
          data-testid="shift-bar"
          className={`relative h-full rounded-full bg-gradient-to-r ${FILL[kind]} shadow-[0_0_18px_rgba(16,185,129,0.35)] transition-[width] duration-1000 ease-out`}
          style={{ width: `${pct}%` }}
        >
          {kind === "working" ? (
            <span className="absolute inset-y-0 w-1/3 animate-track-shine bg-gradient-to-r from-transparent via-white/55 to-transparent" />
          ) : null}
        </div>
      </div>

      <span
        data-testid="shift-knob"
        className={`absolute top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full transition-[inset-inline-start] duration-1000 ease-out ltr:-translate-x-1/2 rtl:translate-x-1/2 ${
          kind === "working" ? "animate-knob-glow" : ""
        }`}
        style={{
          insetInlineStart: `calc(1.375rem + (100% - 2.75rem) * ${pct / 100})`,
          background: KNOB,
          boxShadow: "0 7px 14px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.9) inset, 0 -3px 7px rgba(0,0,0,0.4) inset",
        }}
      >
        <span className="flex h-[70%] w-[70%] items-center justify-center rounded-full"
              style={{ background: "linear-gradient(155deg, #f7f9fb 0%, #c9d2dc 45%, #8a94a1 100%)",
                       boxShadow: "0 -1px 2px rgba(255,255,255,0.9) inset, 0 2px 4px rgba(0,0,0,0.35) inset" }}>
          <span className="flex h-[52%] w-[52%] items-center justify-center rounded-full"
                style={{ background: "radial-gradient(circle at 35% 30%, #ffffff 0%, #dfe5ec 40%, #9aa4b1 100%)",
                         boxShadow: "0 1px 2px rgba(0,0,0,0.35)" }}>
            <span className="h-[40%] w-[40%] rounded-full bg-white/85 shadow-[0_0_3px_rgba(0,0,0,0.35)_inset]" />
          </span>
        </span>
      </span>
    </div>
  </div>
);
